import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getQuestion, removeQuestion } from '../services/services'
import { IQuestion } from '../types';
import { Loader } from './Loader';
import { useNavigate } from 'react-router-dom';
import { User } from '@microsoft/microsoft-graph-types';
import { useTranslation } from 'react-i18next';
import { Header } from './Header';

export const QuestionView: React.FunctionComponent<{ user: User }> = () => {
  const params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const id = params.questionId;

  const [question, setQuestion] = useState<IQuestion>();

  useEffect(() => {
    if (id) {
      getQuestion(id).then(async (res) => { return res.json() }).then((o) => setQuestion(o));
    }
  }, [id]);

  if (!id) {
    navigate("/");
  }

  if (!question) return <Loader isLoading={!question} />;

  return (
    <div className='contents'>
        <Header header={t("questionView.header")} additionalCss="modules-background"/>
        {question && id && (
          <React.Fragment>
              <small dangerouslySetInnerHTML={{ __html: t("questionView.questionAskedBy", {
                  "createdBy": question.creatorDisplayName,
                  "created": new Date(question.created as string).toLocaleDateString()
                })
              }} />
            <br /><br />
          </React.Fragment>
        )}
        {question.answer && question.answer.url && (
          <article className="message is-primary">
            <div className="message-body" dangerouslySetInnerHTML={{ __html: t("questionView.questionAnsweredBy", {
                  "answeredBy": question.answer?.answeredByDisplayName,
                  "answered": new Date(question.answer?.answerDate as string).toLocaleDateString(),
                  "url": question.answer?.url
                })
              }}>
            </div>
          </article>
        )}
        <b>{question.title}</b><br />
        {question.description}
        <br />
        <br />
        <b>{question.titleEn}</b><br />
        {question.descriptionEn}
        <br />
        <br />
        <div className='footerButtons'>
            <div className='buttons is-pulled-right'>
              <Link to="/" className='button is-small'>
                {t("questionView.buttons.back.text")}
              </Link>
              {question.canAnswer && (
                <button className='button is-small' onClick={() => { 
                  navigate(`/questions/${id}/answer`)
                }}>{t("questionView.buttons.editanswer.text")}</button>
              )}
              {question.canEdit && (
                <button className='button is-small' onClick={() => { 
                  navigate(`/questions/${id}/edit`)
                }}>{t("questionView.buttons.editquestion.text")}</button>
              )}
              {question.canDelete && (
                <button className='button is-danger is-small' onClick={(e) => { 
                  e.preventDefault()
                  if (window.confirm(t("common.deleteConfirm"))) {
                    removeQuestion(id as string).then(async (value) => {
                      if (value.ok) {
                        navigate('/');
                      }
                    })
                  }
                }}>{t("questionView.buttons.delete.text")}</button>
              )}
          </div>
        </div>
    </div>
  );
};
